import React, { useCallback, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
//Components
import Form from './Form.constants';
//Redux
import { useSelector, useDispatch } from 'react-redux';
import {
  getWareHouseById,
  updateWarehouse,
} from '../../redux/warehouses/thunks';
import { RootState } from '../../domain/models/RootState';
import useScan from '../../hooks/useScan';

const EditWarehouse = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const { setDestination } = useScan();
  useEffect(() => {
    setDestination('act-e-war', false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { id } = useParams();
  // warehouse a edit
  const { edit } = useSelector((state: RootState) => state.warehouses);

  const submitEditWarehouse = (values: any) => {
    const { name, address, status_warehouses_id } = values;
    dispatch(
      updateWarehouse({ values: { name, address, status_warehouses_id, id } })
    )
      .unwrap()
      .then((res: any) => {
        if (res) {
          navigate('/warehouses', { replace: true });
        }
      });
  };

  const fetchWareHouse = useCallback(() => {
    id && dispatch(getWareHouseById(Number(id)));
  }, [id]);

  useEffect(() => {
    fetchWareHouse();
  }, [id]);
  return (
    <>
      {edit && (
        <Form
          submitWarehouse={submitEditWarehouse}
          initialValues={edit}
          actionText='EDITAR'
        />
      )}
    </>
  );
};

export default EditWarehouse;
